<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>点击右上角<span class="orange">【注册】</span>按钮</p>
        <img src="../../../assets/img/userRes_a.png" alt="" width="911">
        <p class="mt"><strong>第二步：</strong>在弹窗中，选择注册身份<span class="orange">【普通用户注册】</span>，进入注册页面</p>
        <img src="../../../assets/img/userRes_b.png" alt="" width="60%">
        <p><strong>第三步：</strong>请输入您的真实姓名，选择 ○手机号码 ◎ 邮箱 注册方式<br/><span class="orange">注:手机号或邮箱将成为您的登录【用户名】
</span></p>
        <p><strong>【手机号码注册】</strong></p>
        <img src="../../../assets/img/userRes_c.png" alt="">
        <p class="step_three">
          ① 请输入您的手机号，<span class="orange">【点击获取】</span>，展现图形验证码，并输入<br/>
          <img src="../../../assets/img/userRes_d.png" class="mt_10" alt="" width="311"></p>
        <p class="mt_10 step_three">
          ② 请输入图形验证码<br/>
          ③ 点击短信验证码项的<span class="orange">【点击获取】</span>验证码，请查收短信：【心理亦笙】注册验证码，并输入短信验证码<br/>
          ④ 请您阅读《用户注册协议》，如您没有异议请勾选：√我已阅读并同意<br/>
          ⑤ 请点击<span class="orange">【下一步】</span><br/>
          ⑥ 设置登录密码，连续两次输入密码，点击<span class="orange">【注册】</span>按钮，完成注册
        </p>
        <img src="../../../assets/img/userRes_e.png" alt="" height="502">
        <p><strong>【邮箱注册】</strong></p>
        <img src="../../../assets/img/userRes_f.png" alt="" height="430">
        <p class="step_three">
          ① 请输入您的邮箱账号，点击<span class="orange">【发送激活邮箱】</span>，展现图形验证码，并输入<br/>
          <img src="../../../assets/img/userRes_d.png" class="mt_10" alt="" width="311"></p>
        <p class=" mt_10">
          ② 请输入图形验证码<br/>
          ③ 再次点击<span class="orange">【发送激活邮箱】</span><br/>
          <img src="../../../assets/img/userRes_g.png" class="mt_10" alt="">
          ④ 打开个人邮箱网址，与之前输入邮箱账号的保持一致，在【收件箱】中找到【心理亦笙】发送的邮件，点击打开<br/>
          ⑤ 点击邮件中的链接，完成激活，注册完成！<br/>
          <span class="orange">【注：如有【第三方链接提醒】弹窗，点击【继续前往】】</span>
          <img src="../../../assets/img/userRes_h.png" class="mt_10" alt=""><br/>
          ⑥ <span class="orange">【点击登录】</span>，可回到心理亦笙网站进行登录
        </p>

      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh">
          <p><strong>第一步：</strong>在【首页】，点击右上角<span class="orange">【≡】</span>菜单符号，从右侧弹出菜单弹窗</p>
          <p><strong>第二步：</strong>在【菜单列表】中，点击<span class="orange">【立即登录】</span>按钮，进入登录页面</p>
          <p><strong>第三步：</strong>在【登录页面】，点击下侧<span class="orange">【还没有账号，去注册】</span>按钮，进入注册页面</p>
        </div>
        <img src="../../../assets/img/userPhRes_a.png" alt="">
        <p><strong>第四步：</strong>在【注册页面】，按照提示完成信息填写，点击<span class="orange">【注册】</span>按钮，新用户注册完成！</p>
        <div class="flex">
          <img src="../../../assets/img/userPhRes_b.png" alt="" width="67.5%">
          <div>
            <p>
              ① 请您选择获取注册验证码的方式【手机号码】【邮箱】<br/><span class="orange">注：海外用户请选择邮箱(Gmai账户除外)</span><br/>
              ② 请输入【真实姓名】，便于医生了解您<br/>
              ③ 请输入您的手机号或邮箱，<span class="orange">【点击获取】</span>，展现图形验证码并输入。<span
                class="orange">注：手机号或邮箱将成为登录【用户名】</span><br/>
              ④ 请输入图形验证码<br/>
              <img src="../../../assets/img/userRes_d.png" class="mt_10" alt="" width="311">
            </p>
            <p class="mt_10">
              ⑤ 点击短信验证码项的<span class="orange">【点击获取】</span>验证码，请查收短信或邮件：【心理亦笙】注册验证码，并输入短信验证码<br/>
              ⑥ 请您阅读《用户注册协议》，如您没有异议请勾选：√我已阅读并同意<br/>
              ⑦ 请点击<span class="orange">【注册】</span>，新用户注册完成！
            </p>
          </div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>


</template>

<script>
export default {
  name: "resHelp",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
